import React, { useState } from 'react';
import {
  LinkIcon,
  ChatBubbleBottomCenterTextIcon,
  EnvelopeIcon as EnvelopeIconOutline,
} from '@heroicons/react/24/outline';
import Receipt from './receipt';
import { TWButton, TWModal, TWInput } from '../../../components/ui';
import TWSlideOver from '../../../components/slide-over/slide-over';

export default function SlideOver({
  showSlide,
  setShowSlide,
  orderDetail,
  onClickSendEmail,
  onClickSendSms,
  onClickOpenReceiptNewTab,
}) {
  const [email, setEmail] = useState('');
  const [dialogs, setDialogs] = useState({ email: false });
  const [loading, setLoading] = useState({ email: false });

  const onCloseUpsert = () =>
    setDialogs((prev) => ({ ...prev, email: false }));

  const sendEmail = async () => {
    if (orderDetail.email || orderDetail.customer?.email) {
      await onClickSendEmail();
    } else {
      setEmail('');
      setDialogs((prev) => ({ ...prev, email: true }));
    }
  };

  const submitEmail = async () => {
    setLoading((prev) => ({ ...prev, email: true }));
    await onClickSendEmail(email);
    setLoading((prev) => ({ ...prev, email: false }));
    onCloseUpsert();
    setShowSlide(false);
  };

  return (
    <>
      <TWSlideOver
        show={showSlide}
        onClose={() => setShowSlide(false)}
        title="Receipt"
        subtitle="Share or review this order"
        maxWidth="max-w-md"
      >
        <div className="space-y-5">
          <Receipt orderDetail={orderDetail} />
          <div>
            <h1 className="text-sm font-semibold text-slate-900 dark:text-slate-100">
              Share this receipt with Customer:
            </h1>
          </div>
          <div className="flex flex-wrap justify-start gap-2">
            <TWButton
              icon={EnvelopeIconOutline}
              label="E-mail"
              onClick={sendEmail}
            />
            <TWButton
              icon={ChatBubbleBottomCenterTextIcon}
              label="SMS"
              onClick={onClickSendSms}
            />
            <TWButton
              icon={LinkIcon}
              label="Public Link"
              onClick={onClickOpenReceiptNewTab}
            />
          </div>
        </div>
      </TWSlideOver>

      <TWModal
        open={dialogs.email}
        onClose={onCloseUpsert}
        title="Send Receipt by Email"
        size="xl"
        showCloseButton
        footer={
          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <TWButton
              label="Cancel"
              disabled={loading.email}
              onClick={onCloseUpsert}
            />
            <TWButton
              variant="primary"
              label="Send E-Mail"
              loading={loading.email}
              disabled={loading.email}
              onClick={submitEmail}
            />
          </div>
        }
      >
        <TWInput
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail"
        />
      </TWModal>
    </>
  );
}
